module.exports = __webpack_public_path__ + "img/metric_logo_w.7bfb94b9.png";